import styles from '@ui/components/Figure/Figure.module.scss';
import Content from '@ui/components/Content/Content';
import Image from '@ui/components/Image/Image';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const imageHeightMap = {
  small: 239,
  medium: 370,
  large: 536,
  default: 278,
};

const getImageHeight = (variant, fullHeight) =>
  variant === 'full'
    ? fullHeight
    : imageHeightMap[variant] || imageHeightMap.default;

const Figure = ({ caption, height, variant, width, ...props }) => (
  <figure className={styles.figure}>
    <Image
      {...props}
      className={classNames(styles.image, {
        [styles.isFull]: variant === 'full',
      })}
      height={getImageHeight(variant, height)}
      style={
        variant === 'full' ? { aspectRatio: `${width} / ${height}` } : undefined
      }
      width={width}
    />
    {caption && (
      <Content as="figcaption" className={styles.caption} size="sm" withParser>
        {caption}
      </Content>
    )}
  </figure>
);

Figure.propTypes = {
  caption: PropTypes.string,
  height: PropTypes.number,
  variant: PropTypes.oneOf(['small', 'medium', 'large', 'full']),
  width: PropTypes.number,
};

export default Figure;
